// extracted by mini-css-extract-plugin
module.exports = {"footer":"ModalActionsField_footer__jowmH","footer__prevBtn":"ModalActionsField_footer__prevBtn__1m7Tg","footer__submitBtn":"ModalActionsField_footer__submitBtn__mBGHl"};